import dayjs from "dayjs";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import PhoneInput, {
  isValidPhoneNumber,
  parsePhoneNumber,
} from "react-phone-number-input";
import { useSelector } from "react-redux";
import toastr from "toastr";
import { dumpHighPrice } from "../../Services/mainPageService";
import storageService from "../../Services/storageService";
import { fireGtmEvent } from "../../utils/googleAnalytics";
import "./IdleBehaviour.css";

const IdleBehaviour = ({
  showPopup = true,
  setShowPop,
  setextraPrice,
  setShowFakeConfetti,
}) => {
  const [othersText, setOthersText] = useState("");
  const [phone, setPhone] = useState();

  const id = storageService.get("hotelName") || 0;

  const { hotelData, dateRange } = useSelector((state) => state.hotelInfo);

  const onIdle = () => {
    setShowPop(true);
  };

  // const { getRemainingTime } = useIdleTimer({
  //   onIdle,
  //   timeout: 10000,
  //   throttle: 500,
  // });

  const handleReasonSubmit = async () => {
    if (
      othersText?.length === 0 ||
      !/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
        othersText
      )
    ) {
      toastr.info("Please enter valid email!");
      fireGtmEvent("subscribe_popup_wrong_input");
      return;
    }

    if (phone === "" || !isValidPhoneNumber(String(phone))) {
      fireGtmEvent("subscribe_popup_wrong_phone");
      toastr.error(t("enter_valid_phone_number"));
      return;
    }

    const phoneNumber = parsePhoneNumber(String(phone));

    const obj = {
      bookingId: 205,
      hotelId: storageService.get("hotelId"),
      dialCode: "+" + phoneNumber.countryCallingCode,
      mobile: phoneNumber.nationalNumber,
      reason: `Subscribe ${id} - ` + othersText,
      email: othersText,
      checkInDate: dayjs(dateRange?.startDate).format("YYYY-MM-DD"),
      checkOutDate: dayjs(dateRange?.endDate).format("YYYY-MM-DD"),
    };

    if (isValidPhoneNumber(phone)) {
      localStorage.setItem("phone", JSON.stringify(phone));
    }
    localStorage.setItem("email", JSON.stringify(othersText));

    let userHistory = JSON.parse(localStorage.getItem("userHistory")) || {};
    let historyObj = {
      id: hotelData?.id,
      checkInDate: dayjs(dateRange?.startDate).format("YYYY-MM-DD"),
      checkOutDate: dayjs(dateRange?.endDate).format("YYYY-MM-DD"),
      currenDate: dayjs().format("YYYY-MM-DD HH:mm"),
      event: "offer_applied",
    };
    let temp = userHistory[hotelData?.id] || [];
    userHistory = { ...userHistory, [hotelData?.id]: [...temp, historyObj] };
    localStorage.setItem("userHistory", JSON.stringify(userHistory));

    const response = await dumpHighPrice(obj);

    if (response.status === 200) {
      // toastr.success("15% Off Applied, Book now to avail the offer :)");
      setextraPrice(1);
      setOthersText("");
      storageService.set("loyalty", true);
      storageService.set("subscribed", true);
      setShowFakeConfetti(true);
    }
    fireGtmEvent("subscribed_popup");
    setShowPop(false);
  };

  const handleClose = () => {
    othersText?.length > 0 && handleReasonSubmit();
    setShowPop(false);
    setOthersText("");
    fireGtmEvent("subscribe_popup_closed");
  };

  const { t } = useTranslation();

  return (
    showPopup && (
      <div className="checkoutPageModal">
        <div className="checkoutPageContainer" style={{ padding: "0" }}>
          <div
            className="checkoutPageContainerHeader"
            style={{
              background: "#CBD9FF",
              borderRadius: "8px 8px 0 0",
            }}
          >
            <img
              src="https://ik.imagekit.io/hotelzifyprod/a7ea48e7-dd16-4de9-a20f-6e78dfc2c3a7.png?tr=w-300,h-300"
              alt="can we ask why?"
            />
          </div>
          <div
            className="checkoutPageContainerBody"
            style={{ padding: "10px" }}
          >
            <p
              style={{ width: "100%", textAlign: "center", fontSize: "0.8rem" }}
            >
              {t("subscribe_now_to")}
            </p>
            <p
              style={{
                color: "#065af3",
                fontSize: "1.1rem",
                textAlign: "center",
                width: "100%",
              }}
            >
              {t("get_extra")}{" "}
              <b style={{ color: "#065af3" }}>15% {t("off")}!</b>
            </p>
            <div className="inputRow">
              <input
                value={othersText}
                onChange={(e) => setOthersText(e.target.value)}
                name="requests"
                placeholder={t("enter_email")}
              />
              <div className="offer_phone">
                <PhoneInput
                  defaultCountry="IN"
                  placeholder={t("enter_contact_number")}
                  value={phone}
                  className="offerInput"
                  name="phone"
                  onChange={(val) => {
                    setPhone(val);
                  }}
                />
              </div>
              <button onClick={handleReasonSubmit} className="acceptBtn">
                {t("subscribe")}
              </button>
            </div>

            <div
              className="checkoutPageContainerFooter"
              style={{ flexDirection: "column-reverse" }}
            >
              <button onClick={handleClose} className="ignoreBtn">
                {t("no_thanks")}
              </button>
            </div>
          </div>
        </div>
      </div>
    )
  );
};

export default IdleBehaviour;
